import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@pinup-teams/common';

import { FinanceDialogComponent } from './finance-dialog.component';

@Injectable()
export class FinanceDialog {
  #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(FinanceDialogComponent);
  }
}
